import { useEffect } from "react";
import { useTranslation } from "@onefront/react-sdk";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUserLock,
  faUsers,
  faCircleExclamation,
  faTrashCan,
  faStar,
  faFolders,
} from "@fortawesome/pro-regular-svg-icons";
import { Typography } from "@vapor/react-extended";
import { Stack } from "@vapor/react-material";
import { useDocumentList } from "../../state/useDocumentList";

const DocumentFilters = ({ handleFilterChange, documentFilterOption }) => {
  const { t } = useTranslation("DOCS");
  const {
    setIsFiltering,
    setOnFilterChange,
    setHasMoreDocuments,
    setDocumentFilterOption,
  } = useDocumentList();
  const documentFilterOptions = [
    {
      key: "IL_MIO_SPAZIO",
      label: "Il mio spazio",
      icon: faUserLock,
    },
    {
      key: "CONDIVISI",
      label: "Condivisi",
      icon: faUsers,
    },
    {
      key: "URGENTI",
      label: "Urgenti",
      icon: faCircleExclamation,
    },
    {
      key: "PREFERITI",
      label: "Preferiti",
      icon: faStar,
    },
    {
      key: "CESTINO",
      label: "Cestino",
      icon: faTrashCan,
    },
    {
      key: "DOSSIER",
      label: "Dossier",
      icon: faFolders,
    },
  ];

  useEffect(() => {
    const initialOption = documentFilterOptions[1];
    setDocumentFilterOption(initialOption.key);
    handleFilterChange("isFavourite", false);
    handleFilterChange("isUrgent", false);
    handleFilterChange("onlyVisibleToMe", true);
    clickHandler(initialOption);
  }, []);

  const clickHandler = (option) => {
    setOnFilterChange(true);
    setIsFiltering(false);
    setHasMoreDocuments(true);
    setDocumentFilterOption(option.key);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (option.key === "PREFERITI") {
      handleFilterChange("isFavourite", true);
      handleFilterChange("isUrgent", false);
      handleFilterChange("onlyVisibleToMe", false);
    } else if (option.key === "URGENTI") {
      handleFilterChange("isUrgent", true);
      handleFilterChange("isFavourite", false);
      handleFilterChange("onlyVisibleToMe", false);
    } else if (option.key === "CONDIVISI") {
      handleFilterChange("onlyVisibleToMe", false);
      handleFilterChange("isUrgent", false);
      handleFilterChange("isFavourite", false);
    } else if (option.key === "IL_MIO_SPAZIO") {
      handleFilterChange("isUrgent", false);
      handleFilterChange("isFavourite", false);
      handleFilterChange("onlyVisibleToMe", true);
    }
  };

  return (
    <Stack>
      <Typography
        sx={{
          textOverflow: "ellipsis",
          fontFamily: "Roboto",
          fontSize: "14px",
          fontStyle: "normal",
          fontWeight: "500",
          lineHeight: "20px",
        }}
      >
        Documenti
      </Typography>
      {documentFilterOptions.map((option) => (
        <Stack
          onClick={() => clickHandler(option)}
          direction="row"
          sx={{
            display: "flex",
            height: "36px",
            flexDirection: "row",
            cursor: "pointer",
            justifyContent: "start",
            alignItems: "center",
            alignSelf: "stretch",
            gap: "8px",
            background: documentFilterOption === option.key ? "#DBF3FF" : "",
            boxShadow:
              documentFilterOption === option.key
                ? "2px 0px 0px 0px #008BCC inset"
                : " ",
          }}
        >
          <FontAwesomeIcon
            icon={option.icon}
            style={{
              display: "flex",
              width: "16px",
              height: "16px",
              paddingLeft: "12px",
              justifyContent: " center",
              alignItems: "center",
              background: "rgba(255, 255, 255, 0.01)",
            }}
          />
          <Typography
            sx={{
              textOverflow: "ellipsis",
              fontFamily: "Roboto",
              fontSize: "14px",
              fontStyle: "normal",
              fontWeight: "500",
              lineHeight: "20px",
            }}
          >
            {option.label}
          </Typography>
        </Stack>
      ))}
    </Stack>
  );
};

export default DocumentFilters;
